import { render, staticRenderFns } from "./AddTaskTitle.vue?vue&type=template&id=2e71da17"
import script from "./AddTaskTitle.vue?vue&type=script&lang=js"
export * from "./AddTaskTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports